import React from 'react';

const svgBase = {
  viewBox: '0 0 24 24',
  fill: 'none',
  'aria-hidden': true,
  focusable: false,
};

function StrokeG({ children }) {
  return (
    <g stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      {children}
    </g>
  );
}

export function EventCardIcon({ type, className = 'event-card-icon-svg', size = 16 }) {
  switch (type) {
    case 'host':
      return (
        <svg {...svgBase} className={className} width={size} height={size}>
          <path
            d="M5 19h14l1-10-5 3-3-6-3 6-5-3 1 10z"
            fill="currentColor"
            opacity="0.16"
          />
          <StrokeG>
            <path d="M5 19h14l1-10-5 3-3-6-3 6-5-3 1 10z" />
            <path d="M8 19h8" />
          </StrokeG>
        </svg>
      );
    case 'participant':
      return (
        <svg {...svgBase} className={className} width={size} height={size}>
          <StrokeG>
            <circle cx="12" cy="12" r="8" />
            <path d="M8.5 12.2l2.3 2.3 4.9-5" />
          </StrokeG>
        </svg>
      );
    case 'mail':
      return (
        <svg {...svgBase} className={className} width={size} height={size}>
          <StrokeG>
            <rect x="4" y="6" width="16" height="12" rx="2.4" />
            <path d="M5 8l7 5 7-5" />
          </StrokeG>
        </svg>
      );
    case 'hourglass':
      return (
        <svg {...svgBase} className={className} width={size} height={size}>
          <StrokeG>
            <path d="M8 4h8v3l-4 5 4 5v3H8v-3l4-5-4-5V4z" />
            <path d="M9 12h6" />
          </StrokeG>
        </svg>
      );
    case 'friend':
      return (
        <svg {...svgBase} className={className} width={size} height={size}>
          <StrokeG>
            <circle cx="9" cy="8.5" r="3" />
            <path d="M4 19v-.4a5 5 0 0 1 5-5" />
            <path d="M15 9.5c.5-.9 1.8-1 2.5-.2.7-.8 2-.7 2.5.2.9 1.6-1.3 3.4-2.5 4.2-1.2-.8-3.4-2.6-2.5-4.2z" />
          </StrokeG>
        </svg>
      );
    case 'user':
      return (
        <svg {...svgBase} className={className} width={size} height={size}>
          <StrokeG>
            <circle cx="12" cy="8" r="3.4" />
            <path d="M5.5 20a6.5 6.5 0 0 1 13 0" />
          </StrokeG>
        </svg>
      );
    case 'calendar':
      return (
        <svg {...svgBase} className={className} width={size} height={size}>
          <StrokeG>
            <rect x="4" y="5" width="16" height="15" rx="2.2" />
            <path d="M4 10h16M8 3.5v3M16 3.5v3" />
          </StrokeG>
        </svg>
      );
    case 'clock':
      return (
        <svg {...svgBase} className={className} width={size} height={size}>
          <StrokeG>
            <circle cx="12" cy="12" r="8" />
            <path d="M12 8v4l3 2" />
          </StrokeG>
        </svg>
      );
    case 'alarm':
      return (
        <svg {...svgBase} className={className} width={size} height={size}>
          <StrokeG>
            <circle cx="12" cy="13" r="6.5" />
            <path d="M12 10v3.5l2.4 1.6M6.5 4.8L4 7M17.5 4.8L20 7M8.5 20l-1 1.3M15.5 20l1 1.3" />
          </StrokeG>
        </svg>
      );
    case 'location':
      return (
        <svg {...svgBase} className={className} width={size} height={size}>
          <StrokeG>
            <path d="M12 21s-6-4.9-6-10a6 6 0 1 1 12 0c0 5.1-6 10-6 10z" />
            <circle cx="12" cy="11" r="2.2" />
          </StrokeG>
        </svg>
      );
    case 'clipboard':
      return (
        <svg {...svgBase} className={className} width={size} height={size}>
          <StrokeG>
            <path d="M9 5h6l1 2h2v13H6V7h2l1-2z" />
            <path d="M9 11h6M9 15h4" />
          </StrokeG>
        </svg>
      );
    case 'users':
      return (
        <svg {...svgBase} className={className} width={size} height={size}>
          <StrokeG>
            <circle cx="8.5" cy="8.5" r="3" />
            <path d="M3.5 20v-.4a5 5 0 0 1 10 0v.4" />
            <circle cx="17" cy="9.5" r="2.5" />
            <path d="M14.5 15.2a4.5 4.5 0 0 1 6 4.3v.5" />
          </StrokeG>
        </svg>
      );
    case 'alert':
      return (
        <svg {...svgBase} className={className} width={size} height={size}>
          <StrokeG>
            <path d="M12 3.5L3 19.5h18L12 3.5z" />
            <path d="M12 9.5V14M12 16.2v.1" />
          </StrokeG>
        </svg>
      );
    default:
      return null;
  }
}
